import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { filePDFViewerComponent } from './filePDFViewer.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { A11yModule } from '@angular/cdk/a11y';
import { PanelModule } from 'primeng-lts/panel';
import { ToolbarModule } from 'primeng-lts/toolbar';
import { ToggleButtonModule } from 'primeng-lts/togglebutton';

@NgModule({
  declarations: [filePDFViewerComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ToolbarModule,
    PanelModule,
    A11yModule,
    PdfViewerModule,
    ToggleButtonModule
  ],
  exports: [filePDFViewerComponent]
})
export class FilePDFViewerModule { }
